import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { SvgComponent } from '../svg/svg.component';
import { NewSubscriptionsResponse } from '@core/contracts/data-contracts';
import { BundleSubType, BundleType } from '@core/models';
import dayjs from 'dayjs';
import { DateFormatPipe } from '../../../core/pipes/date-format.pipe';

@Component({
  selector: 'sc-subscription-summary',
  imports: [TranslatePipe, AsyncPipe, SvgComponent, CurrencyPipe, DateFormatPipe],
  templateUrl: './subscription-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSummaryComponent {
  bundles = input<NewSubscriptionsResponse>(null);

  dataBundleId = input<number>();
  voiceBundleId = input<number>();
  dataCeilingEnabled = input<boolean>();
  voiceCeilingEnabled = input<boolean>();
  speedUpgradeEnabled = input<boolean>();
  internationalVoiceEnabled = input<boolean>();
  internationalDataEnabled = input<boolean>();

  dataBundle = computed(() =>
    this.bundles()
      ?.bundles.filter((b) => b.subscriptionTypeId === BundleType.Internet)
      ?.find((b) => b.id === this.dataBundleId())
  );
  voiceBundle = computed(() =>
    this.bundles()
      ?.bundles.filter((b) => b.subscriptionTypeId === BundleType.CallSms)
      ?.find((b) => b.id === this.voiceBundleId())
  );
  dataCeilingBundle = computed(() =>
    this.bundles()?.ceilings.find(
      (bundle) => bundle.subscriptionSubTypeId === BundleSubType.DataCeiling
    )
  );
  speedUpgradeBundle = computed(() => this.bundles()?.dataSpeedSubscriptions[0]);
  voiceCeilingBundle = computed(() =>
    this.bundles()?.ceilings.find(
      (bundle) => bundle.subscriptionSubTypeId === BundleSubType.VoiceCeiling
    )
  );
  internationalVoiceBundle = computed(() =>
    this.bundles()?.internationalVoiceSubscriptions.find(
      (bundle) =>
        bundle.subscriptionTypeId === BundleType.CallSms &&
        bundle.subscriptionSubTypeId === BundleSubType.InternationalVoice
    )
  );
  internationalDataBundle = computed(() =>
    this.bundles()?.internationalVoiceSubscriptions.find(
      (bundle) =>
        bundle.subscriptionTypeId === BundleType.Internet &&
        bundle.subscriptionSubTypeId === BundleSubType.InternationalData
    )
  );

  totalPrice = computed(() => {
    let totalPrice = 0;

    if (this.dataCeilingEnabled()) {
      totalPrice += this.dataCeilingBundle().subscriptionPrice;
    }
    if (this.voiceCeilingEnabled()) {
      totalPrice += this.voiceCeilingBundle().subscriptionPrice;
    }
    if (this.speedUpgradeEnabled()) {
      totalPrice += this.speedUpgradeBundle().subscriptionPrice;
    }
    if (this.internationalVoiceEnabled()) {
      totalPrice += this.internationalVoiceBundle().subscriptionPrice;
    }
    if (this.internationalDataEnabled()) {
      totalPrice += this.internationalDataBundle().subscriptionPrice;
    }
    if (this.dataBundleId()) {
      totalPrice += this.dataBundle().subscriptionPrice - this.dataBundle().discountSize;
    }
    if (this.voiceBundleId()) {
      totalPrice += this.voiceBundle().subscriptionPrice - this.voiceBundle().discountSize;
    }

    return totalPrice;
  });

  effectiveDate = signal(dayjs().add(1, 'month').startOf('month').toDate());
}
